import { useRef } from 'react';
import { date } from '../../utils';
export function useDatePickerBase(props, usePickerState) {
    const { value, onChange, minValue, maxValue, withTime, defaultValue, disabled, readOnly, name, timeZone, } = props;
    const dateValue = date.stringToDate(value, withTime);
    const defaultDate = date.stringToDate(defaultValue, withTime);
    const minDate = date.stringToDate(minValue, withTime);
    const maxDate = date.stringToDate(maxValue, withTime);
    const state = usePickerState({
        ...props,
        isDisabled: disabled,
        isReadOnly: readOnly,
        value: dateValue,
        defaultValue: defaultDate,
        onChange: ((value) => {
            if (!value) {
                onChange === null || onChange === void 0 ? void 0 : onChange(value);
                return;
            }
            if ('start' in value) {
                onChange === null || onChange === void 0 ? void 0 : onChange({
                    start: date.dateToString(value.start, timeZone),
                    end: date.dateToString(value.end, timeZone),
                });
                return;
            }
            onChange === null || onChange === void 0 ? void 0 : onChange(date.dateToString(value, timeZone));
        }),
        shouldCloseOnSelect: true,
        minValue: minDate,
        maxValue: maxDate !== null && maxDate !== void 0 ? maxDate : undefined,
        autoFocus: false,
        granularity: withTime ? 'minute' : 'day',
        hideTimeZone: true,
        placeholderValue: date.now(timeZone),
    });
    const groupRef = useRef(null);
    const inputRef = useRef(null);
    return {
        hiddenInputProps: {
            name,
            value: !value ? '' : typeof value === 'string' ? value : `${value.start} ${value.end}`,
            tabIndex: -1,
            readOnly: true,
            type: 'text',
        },
        state: state,
        groupRef,
        inputRef,
    };
}
